import { AcademicCapIcon, CalendarDaysIcon, PhoneIcon } from '@heroicons/react/24/outline';

const Doctors = () => {
  const doctors = [
    {
      id: 1,
      name: "Dr. Ramon Horacio Limón Rodríguez",
      specialty: "Cardiología clínica",
      experience: "25 años de experiencia",
      education: "Universidad Nacional Autónoma de México",
      specialties: [
        "Ecocardiografía Doppler en reposo y estrés",
        "Ecocardiografía carotidea",
        "Arritmias Cardíacas",
        "Cateterismo Cardíaco",
        "Pruebas de Esfuerzo",
        "Holter de Ritmo",
        "Angioplastia coronaria",
        "Stents Coronarios",
        "Ecocardiografía",
        "Prevención Cardiovascular",
        "Marcapasos y Desfibriladores",
        "Insuficiencia Cardíaca"
      ],
      image: "/ramon.png",
      rating: 5.0,
      consultations: "20,000+"
    },
    {
      id: 3,
      name: "Lic. Norma Díaz Ibarra",
      specialty: "Psicoanalista",
      experience: "Cédula Lic. Psicología 3138535 | Cédula de Psicoanalista 14230235",
      education: "Universidad Autónoma de Nuevo León",
      specialties: [
        "Psicoterapia",
        "Urgencias Psicológicas",
        "Tanatología",
        "Adolescentes",
        "Adultos",
        "Atención psicológica de enfermedades crónicas",
        "Cáncer, obesidad, diabetes, artritis"
      ],
      image: "/norma.png",
      imagePosition: "object-top scale-150 origin-top",
      rating: 4.8,
      consultations: "20,000+"
    },
    {
      id: 2,
      name: "Dr. Pedro Limón Rodríguez",
      specialty: "Pediatría",
      experience: "Cédula de especialista 3873879 | Cédula profesional 2939999 | Certificado por el Consejo Mexicano de Pediatría 12202",
      education: "Universidad Autónoma de Nuevo León",
      specialties: [
        "Consulta médica pediátrica",
        "Control del Niño Sano",
        "Carta para pasaporte",
        "Formatos de guardería",
        "Alimentación complementaria",
        "Atención al recién nacido",
        "Vacunas",
        "Consulta de adolescentes",
        "Seguimiento de prematuros"
      ],
      cedEspecialista: "3873879",
      cedProfesional: "2939999",
      certificadoConsejo: "12202",
      image: "/pediatra_image.jpg",
      rating: 4.9,
      consultations: "20,000+"
    },
    {
      id: 4,
      name: "Dr. Rafael Ernesto Zamorano Anaya",
      specialty: "Cardiología clínica",
      experience: "25 años de experiencia",
      education: "Universidad Nacional Autónoma de México",
      specialties: [
        "Ecocardiografía Doppler en reposo y estrés",
        "Ecocardiografía carotidea",
        "Arritmias Cardíacas",
        "Cateterismo Cardíaco",
        "Pruebas de Esfuerzo",
        "Holter de Ritmo",
        "Angioplastia coronaria",
        "Stents Coronarios",
        "Ecocardiografía",
        "Prevención Cardiovascular",
        "Marcapasos y Desfibriladores",
        "Insuficiencia Cardíaca"
      ],
      image: "/photo_rafa.jpg",
      imagePosition: "object-top",
      rating: 5.0,
      consultations: "20,000+"
    }
  ];

  return (
    <>
      <section id="doctores" className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-accent/5 via-surface to-background">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-12 sm:mb-16">
            <div className="inline-flex items-center px-3 sm:px-4 py-2 bg-primary/10 text-primary text-xs sm:text-sm font-semibold rounded-full mb-6 sm:mb-8">
              <AcademicCapIcon className="h-3 w-3 sm:h-4 sm:w-4 mr-2" />
              Nuestro Equipo
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4 sm:mb-6 px-4 sm:px-0">
              Especialistas <span className="text-marino">Certificados</span>
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-text-secondary max-w-3xl mx-auto leading-relaxed px-4 sm:px-0 text-justify">
              Conoce a nuestro equipo de especialistas altamente capacitados,
              cada uno especializado en diferentes áreas de la cardiología moderna.
            </p>
          </div>

          {/* Doctors Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16 lg:mb-20">
            {doctors.map((doctor) => (
              <div
                key={doctor.id}
                className="group bg-surface rounded-xl sm:rounded-2xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-2 border border-border"
              >
                {/* Doctor Image - Circular */}
                <div className="flex justify-center pt-6 sm:pt-8 pb-4">
                  <div className="relative">
                    <div className="w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 rounded-full overflow-hidden border-4 border-primary/20 shadow-lg group-hover:shadow-xl transition-all duration-300">
                      <img
                        src={doctor.image}
                        alt={doctor.name}
                        className={`w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 ${doctor.imagePosition || "object-center"}`}
                      />
                    </div>
                    <div className="absolute inset-0 rounded-full bg-gradient-to-t from-primary/10 via-transparent to-transparent group-hover:from-primary/20 transition-all duration-300" />
                  </div>
                </div>

                {/* Doctor Info */}
                <div className="p-6 sm:p-8 bg-gradient-to-b from-surface/60 to-surface">
                  <div className="mb-4 sm:mb-6">
                    <h3 className="text-xl sm:text-2xl font-bold text-primary mb-2">
                      {doctor.name}
                    </h3>
                    <p className="text-black font-semibold text-base sm:text-lg mb-1">
                      {doctor.specialty}
                    </p>
                    <p className="text-text-secondary text-sm">
                      {doctor.experience}
                    </p>
                  </div>

                  {/* Specialties */}
                  <div className="mb-6 sm:mb-8">
                    <p className="text-sm font-medium text-primary mb-3">Servicios</p>
                    <div className="flex flex-wrap gap-2">
                      {doctor.specialties.map((specialty, index) => (
                        <span
                          key={index}
                          className="px-2 sm:px-3 py-1 bg-accent/10 text-black text-xs font-medium rounded-full border border-accent/20"
                        >
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>

  <div className="space-y-3 mt-6">
  {/* Botón Primario con ícono */}
  <a
    href="#contacto"
    className="
      w-full inline-flex items-center justify-center
      px-4 sm:px-6 py-3
      bg-primary text-white font-semibold font-sans
      text-sm sm:text-base rounded-xl
      transition-all duration-300
      shadow-md

      hover:scale-[1.03] hover:bg-primary/90
      hover:shadow-[0_4px_18px_rgba(30,55,89,0.35)]
      focus:outline-none focus:ring-2 focus:ring-primary/30
    "
  >
    <CalendarDaysIcon className="h-4 w-4 sm:h-5 sm:w-5 mr-2" />
    Agendar Cita
  </a>

  {/* Botón Secundario con ícono */}
  <a
    href="https://wa.me/528112419864"
    target="_blank"
    rel="noopener noreferrer"
    className="
      w-full inline-flex items-center justify-center
      px-4 sm:px-6 py-3
      border-2 border-accent text-primary font-semibold font-sans
      text-sm sm:text-base rounded-xl
      transition-all duration-300
      shadow-sm

      hover:scale-[1.03] hover:bg-accent/20 hover:border-accent
      hover:text-primary
      hover:shadow-[0_4px_18px_rgba(30,55,89,0.15)]
      focus:outline-none focus:ring-2 focus:ring-accent/30
    "
  >
    <PhoneIcon className="h-4 w-4 sm:h-5 sm:w-5 mr-2" />
    Contactar
  </a>
</div>

                </div>
              </div>
            ))}
          </div>

          {/* Encabezado y Métricas */}
          <div className="bg-surface rounded-xl sm:rounded-2xl p-6 sm:p-8 lg:p-12 shadow-card">
            {/* Encabezado */}
            <div className="text-center mb-6 sm:mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-primary mb-3 sm:mb-4 px-4 sm:px-0">
                Un Equipo Comprometido con tu Salud
              </h3>
              <p className="text-text-secondary text-sm sm:text-base lg:text-lg max-w-2xl mx-auto px-4 sm:px-0 text-justify">
                Nuestros especialistas trabajan en conjunto para brindarte
                la mejor atención cardiovascular integral.
              </p>
            </div>

            {/* Métricas */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
              <div className="text-center">
                <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-primary mb-2">20,000+</div>
                <div className="text-text-secondary text-xs sm:text-sm lg:text-base">Pacientes Atendidos</div>
              </div>
              <div className="text-center">
                <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-primary mb-2">45+</div>
                <div className="text-text-secondary text-xs sm:text-sm lg:text-base">Años de Experiencia Combinada</div>
              </div>
              <div className="text-center">
                <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-primary mb-2">98%</div>
                <div className="text-text-secondary text-xs sm:text-sm lg:text-base">Satisfacción del Paciente</div>
              </div>
              <div className="text-center">
                <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-primary mb-2">6</div>
                <div className="text-text-secondary text-xs sm:text-sm lg:text-base">Especialistas</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Doctors;
